import { darkTheme } from "./dark-theme.constant";
import { lightTheme } from "./light-theme.constant";

export const themeOptions = [lightTheme, darkTheme];
